import { render, staticRenderFns } from "./FeaturedSkeleton.vue?vue&type=template&id=c6c9c678&scoped=true&"
var script = {}
import style0 from "./FeaturedSkeleton.vue?vue&type=style&index=0&id=c6c9c678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c9c678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c9c678')) {
      api.createRecord('c6c9c678', component.options)
    } else {
      api.reload('c6c9c678', component.options)
    }
    module.hot.accept("./FeaturedSkeleton.vue?vue&type=template&id=c6c9c678&scoped=true&", function () {
      api.rerender('c6c9c678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/Skeletons/FeaturedSkeleton.vue"
export default component.exports